import { NgClass } from '@angular/common';
import { booleanAttribute, Component, Input, HostBinding } from '@angular/core';

//Composant simple panel
@Component(
	{
		selector: 'val-simple-panel',
		imports:
			[
				NgClass
			],
		templateUrl: './simple-panel.component.html',
		styleUrl: './simple-panel.component.scss'
	})
export class SimplePanelComponent {
	//Création
	constructor() {
		this.cacherContenu = false;
	}

	//Indique si le contenu est caché
	@Input({ transform: booleanAttribute })
	public cacherContenu: boolean;

	@Input()
	public couleurFond?: string;

	@Input()
	public couleurBord?: string;

	@Input()
	public couleurTitre?: string;

	@HostBinding('style')
	get styleHote(): Partial<CSSStyleDeclaration> {
		return {
			'--panel-couleur-fond': this.couleurFond,
			'--panel-couleur-bord': this.couleurBord,
			'--entete-panel-couleur-titre': this.couleurTitre
		} as Partial<CSSStyleDeclaration>;
	}
}
